import { SalesPartnerCreateCustomerLanguageEnum } from "@/services/model/salesPartnerCreateCustomerLanguageEnum";

// Helper function to map language enum to translation key
export const getLanguageTranslationKey = (enumValue: string) => {
  const mapping: Record<string, string> = {
    [SalesPartnerCreateCustomerLanguageEnum.DE]: "german",
    [SalesPartnerCreateCustomerLanguageEnum.EN]: "english",
    [SalesPartnerCreateCustomerLanguageEnum.FR]: "french",
  };

  return mapping[enumValue] || enumValue;
};
